import type { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { lightOrDark } from "@app/embedded/theme/utils";

import Stack, { Row, StackProps } from "@rui/Stack";

export const MenuHeader = styled((props: StackProps) => (
  <Row spacing={1} alignItems="center" {...props} />
))(({ theme }) => ({
  padding: "16px 24px",
  borderBottom: `1px solid ${theme.palette.shades.neutral[100]}`,
  fontWeight: 500,
  "& svg": {
    color: theme.palette.shades.neutral[300],
    height: "16px",
    width: "16px",
  },
}));

export const MenuBody = styled(Stack)(({ theme }) => ({
  padding: "16px 24px",
  color: lightOrDark(theme.palette.shades.neutral[800], "#fff")(theme),
  backgroundColor: lightOrDark(
    "#FFF",
    theme.palette.shades.neutral[800]
  )(theme),
}));

export const MenuDivider = styled(Divider)(({ theme }) => ({
  margin: "8px 0",
  borderBottomColor: theme.palette.shades.neutral[50],
}));

export const MenuTitle = ({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) => {
  return (
    <Stack sx={sx}>
      <Box component="li">
        <Typography variant="bodySecondaryMed" color="shades.neutral.800">
          {children}
        </Typography>
      </Box>
      <MenuDivider />
    </Stack>
  );
};
